import { Injectable } from '@angular/core';
import {
  CREATE_SEASON,
  GET_SEASONS,
  NewSeasonPostBody,
  SeasonData,
  SeasonDataSansCompetitions,
  SeasonStatus,
  UPDATE_SEASON,
} from '@pool-league/shared-data-api';
import { Observable } from 'rxjs';
import { PoolLeagueApiClient } from '../base-client/pool-league-api-client';

@Injectable({ providedIn: 'root' })
export class SeasonApiClient extends PoolLeagueApiClient {
  readonly #getSeasons = this.buildRequest(GET_SEASONS);
  readonly #createSeason = this.buildRequest(CREATE_SEASON);

  constructor() {
    super();
  }

  createSeason(seasonInfo: NewSeasonPostBody): Observable<SeasonData> {
    return this.#createSeason.post<SeasonData>(seasonInfo);
  }

  listSeasons(
    limit = 20,
    cursor?: string,
  ): Observable<{
    seasons: SeasonDataSansCompetitions[];
    moreAvailable: boolean;
  }> {
    return this.#getSeasons.get<{
      seasons: SeasonDataSansCompetitions[];
      moreAvailable: boolean;
    }>({
      params: cursor ? { limit, cursor } : { limit },
    });
  }

  getBySlug(slug: string): Observable<SeasonData> {
    return this.#getSeasons.get<SeasonData>({
      params: { slug },
    });
  }

  setStatus(
    seasonId: string,
    status: SeasonStatus,
  ): Observable<SeasonDataSansCompetitions> {
    return this.buildRequest(UPDATE_SEASON, {
      seasonId,
    }).patch<SeasonDataSansCompetitions>({
      status,
    });
  }
}
